module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_3-133161731332d5c23997f9728247d134.jpg";